import { SiteHeader } from '../features/landing/SiteHeader.tsx';
import { Hero } from '../features/landing/Hero.tsx';
import { AppIndex } from '../features/landing/AppIndex.tsx';
import { ProductSection } from '../features/landing/ProductSection.tsx';
import { WhyOffice } from '../features/landing/WhyOffice.tsx';
import { Pricing } from '../features/landing/Pricing.tsx';
import { ClosingCTA } from '../features/landing/ClosingCTA.tsx';
import { SiteFooter } from '../features/landing/SiteFooter.tsx';
import { products } from '../features/landing/products.ts';
import { useMarketingChrome } from '../features/landing/useMarketingChrome.ts';
import { useReveal } from '../features/landing/useReveal.ts';

export function Landing(): JSX.Element {
  useMarketingChrome();
  useReveal();

  return (
    // Same shell as the logged-in app: the tinted --chrome ground carries the
    // header, and the page content sits on a white panel with rounded top
    // corners floating on it.
    <div id="top" className="landing-dv overflow-x-clip bg-[hsl(var(--chrome))] text-foreground">
      <SiteHeader />
      <div className="landing-panel">
        <Hero />
        <AppIndex />
        <div id="products">
          {products.map((p, i) => (
            <ProductSection key={p.key} product={p} index={i} />
          ))}
        </div>
        <WhyOffice />
        <Pricing />
        <ClosingCTA />
      </div>
      <SiteFooter />
    </div>
  );
}
